
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"6.1 263 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 267.5c-7.4 0-13.5 6.1-13.5 13.5s6.1 13.5 13.5 13.5 13.5-6.1 13.5-13.5-6-13.5-13.5-13.5zm.9 4.4l3.5-1.8c1.9.7 3.5 1.9 4.9 3.5l-.9 3.8-2.7 1.3-4.9-3.5v-3.3h.1zm-5.1-1.8l3.5 1.8v3.3l-4.9 3.5-2.7-1.3-.9-3.9c1.3-1.5 3-2.7 5-3.4zm-5.5 17.6c-1.1-1.6-1.8-3.5-2.1-5.5l2.9-3 2.6 1.2 1.9 5.6-1.7 1.9-3.6-.2zm12.8 4.7c-1 .2-1.9.4-3 .4-1.2 0-2.4-.2-3.5-.6l-1.1-3.3 1.7-2.1h6l1.7 1.9-1.8 3.7zm2.9-4.6l-1.6-1.9 1.9-5.6 2.6-1.2 2.8 3c-.1 1.8-.7 3.4-1.6 4.9l-4.1.8z","fill":"#fff"}})])
          )
        }
      }
    